import React, { Fragment } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Form, Header, Input, Button, Icon, TextArea, Divider, Grid, Loader, Segment, Message } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import PropTypes from 'prop-types';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

/**
 * <State>
 * studentLock object that wraps the form information
 *
 * <Props>
 * sendStudentLock(studentLock) - func
 * studentStudyProgramId - number
 * studnetStudyProgramOptLock - number
 * hasThesis - boolean
 */

export default class StudentLockForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            disabled: true,
            marks: [],
            employees: [],
            studentLock: {
                diplomaNumber: null,
                limitation: false,
                comment: null,
                additionalActivities: null,
                commentTranslation: null,
                date: this.props.limitation ? null : null,
                theme: null,
                themeEnglish: null,
                thesisComment: null,
                thesisDate: this.props.limitation ? null : null,
                themeApprovalDecisionDate: this.props.limitation ? null : null,
                mark: null,
                committeeAppointmentDecisionNumber: null,
                committeeAppointmentDecisionDate: this.props.limitation ? null : null,
                mentor: null,
                comentor: null,
                committeePresident: null,
                committeeMember1: null,
                committeeMember2: null,
                reservedMember: null,

                mentorId: null,
                comentorId: null,
                committeePresidentId: null,
                committeeMember1Id: null,
                committeeMember2Id: null,
                reservedMemberId: null,

                themeTranslation: null,
                thesisCommentTranslation: null,

                optLock: null,
                thesisId: null,
                thesisOptLock: null,

                thesisPresentationId: null,
                thesisPresentationOptLock: null,

                thesisPresentationMarkId: null,
                thesisPresentationMarkOptLock: null,
            },
            thesis: true,
            confirmation: false,
            confirmationUnlock: false,

            diplomaNumberErr: false,
            themeErr: false,
            markErr: false,
            hideButtons: false,
            notEnrolled: false,
            loader: true,
            sendPfInfo: false,
            isPf: false,
            notPassedCourses: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChange_ = this.handleInputChange_.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.fetchLookups = this.fetchLookups.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.lock = this.lock.bind(this);
        this.checkFinalCourseOnSp = this.checkFinalCourseOnSp.bind(this);
        this.checkNotPassedCourses = this.checkNotPassedCourses.bind(this);
        this.checkOldSpForPf = this.checkOldSpForPf.bind(this);
        this.saveButtonValidation = this.saveButtonValidation.bind(this);
        this.saveZR1Validation = this.saveZR1Validation.bind(this);
        this.saveZR2Validation = this.saveZR2Validation.bind(this);
        this.saveZR3Validation = this.saveZR3Validation.bind(this);
        this.saveZR4Validation = this.saveZR4Validation.bind(this);
        this.saveZR5Validation = this.saveZR5Validation.bind(this);
    }

    componentWillMount() {
        this.checkFinalCourseOnSp();
    }

    componentDidMount() {
        const {
            studyProgramId, studentStudyProgramId
        } = this.props;
        if (localStorage.getItem('activeRole').substr(0, 30) === 'Studentska: Pedagoški fakultet') {
            this.setState({ isPf: true });
            this.checkOldSpForPf(studyProgramId);
        }

        this.checkNotPassedCourses(studentStudyProgramId);
    }

    checkNotPassedCourses(studentStudyProgramId) {
        axios.get(`course/basic/not-passed/${studentStudyProgramId}/`)
            .then(result => {
                let courses = result.data ? result.data : [];
                this.setState({
                    notPassedCourses: !!courses.length
                });
            })
            .catch(err => {
                console.log('Failed to fetch not passed courses.');
            });
    }
    checkOldSpForPf(studyProgramId) {
        axios.get(`study-programs/izrada-diplomskog-rada/${studyProgramId}/`).then((res) => {
            if (res.data === true) {
                this.setState({ sendPfInfo: true });
            } else {
                this.setState({ sendPfInfo: false });
            }
        }).catch((err) => {
            console.log('Failed to check old sp!');
        });
    }

    sendAdditionalInfoForPf() {
        axios.post('/grade-student/izrada-diplomskog-rada/', {
            date: this.state.studentLock.date,
            studentStudyProgramId: this.props.studentStudyProgramId
        }).then((res) => {
            console.log('res:', res.data);
        }).catch((err) => {
            console.log('Failed to post additional info for pf!');
        });
    }

    lock() {
        console.log('lock');
        let studentLock = {
            id: this.props.studentStudyProgramId,
            optLock: this.state.studentLock.optLock
        };

        axios.post('/students/lock/', { ...studentLock })
            .then(res => {
                toast('Student je uspješno zaključan.');
                this.props.updateStudentStatuses();
                this.props.toggleLockedVisibility();
                this.fetchData(this.props.studentStudyProgramId);
                this.setState({ hideButtons: true, confirmation: false, confirmationUnlock: false });
            })
            .catch(err => {
                if (err.message === 'Network Error') {
                    toast('Student je uspješno zaključan.');
                    this.props.updateStudentStatuses();
                    this.props.toggleLockedVisibility();
                    this.fetchData(this.props.studentStudyProgramId);
                    this.setState({ hideButtons: true, confirmation: false, confirmationUnlock: false });
                } else {
                    toast('Došlo je do greške! Student nije zaključan.');
                }
            });
    }

    unlock() {
        let studentLock = {
            id: this.props.studentStudyProgramId,
            optLock: this.state.studentLock.optLock
        };

        axios.put(`students/unlock-student-study-program/${this.props.studentStudyProgramId}`)
            .then(res => {
                toast('Student je uspješno otključan.');
                this.props.updateStudentStatuses();
                this.props.toggleLockedVisibility();
                this.fetchData(this.props.studentStudyProgramId);
                this.setState({ hideButtons: false, confirmation: false, confirmationUnlock: false });
            })
            .catch(err => { toast('Došlo je do greške! Student nije otključan.'); });
    }

    fetchLookups() {
        // axios.get('/employees/all-academic-staff') text: el.person.firstName + ' ' + el.person.lastName,
        axios.all([axios.get('/marks'), axios.get('/professor-thesis-roles'), axios.post('/employees/by-key/professor', {})])
            .then(axios.spread((marksRes, roleRes, employeesRes) => {
                const marks = marksRes.data.map(el => ({
                    ...el, value: el.id, key: el.id, text: el.displayName,
                })).filter(el => el.key_ !== 'uo');

                const employees = employeesRes.data.map(el => ({
                    ...el, value: el.id, key: el.id, text: el.firstName + ' ' + el.lastName,
                }));

                const committeeRoles = roleRes.data;
                this.setState({
                    marks,
                    committeeRoles,
                    employees
                }, () => this.fetchData(this.props.studentStudyProgramId));
            }))
            .catch(err => {
                console.log(err);
            });
    }

    fetchData(studentStudyProgramId) {
        let { studentLock } = this.state;
        axios.get(`/students/${studentStudyProgramId}/`)
            .then(res => {
                studentLock = {
                    ...studentLock,
                    optLock: res.data.optLock,
                    diplomaNumber: res.data.diplomaNumber,
                    locked: res.data.locked,
                    comment: res.data.additionalActivities,
                    additionalActivities: res.data.translations[0] && res.data.translations[0].additionalActivities ? res.data.translations[0].additionalActivities : null,
                    date: res.data.graduationDate ? res.data.graduationDate : null,
                    mark: null,
                    // mark: this.state.marks.find(e => e.text === 'uspješno odbranjen').value,

                };

                axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') ? `/students/thesis-for-admin/${studentStudyProgramId}/`
                    : `/students/thesis/${studentStudyProgramId}/`)
                    .then(thesisRes => {
                        if (thesisRes.data.length > 0) {
                            if (thesisRes.data[0].theme !== '') { this.setState({ disabled: false }); }
                            studentLock = {
                                ...studentLock,
                                theme: thesisRes.data[0].theme,
                                thesisComment: thesisRes.data[0].comment ? thesisRes.data[0].comment : null,
                                thesisId: thesisRes.data[0].id,
                                thesisOptLock: thesisRes.data[0].optLock,
                                themeEnglish: thesisRes.data[0].translations.length ? thesisRes.data[0].translations[0].theme : null,
                                committeeAppointmentDecisionDate: thesisRes.data[0].committeeAppointmentDecisionDate,
                                committeeAppointmentDecisionNumber: thesisRes.data[0].committeeAppointmentDecisionNumber,
                                themeApprovalDecisionDate: thesisRes.data[0].themeApprovalDecisionDate,
                                themeApprovalDecisionNumber: thesisRes.data[0].themeApprovalDecisionNumber,

                            };
                            axios.get(`/students/thesis-presentation/${thesisRes.data[0].id}/`)
                                .then(thesisPresentationRes => {
                                    if (thesisPresentationRes.data.length > 0) {
                                        studentLock = {
                                            ...studentLock,
                                            thesisDate: thesisPresentationRes.data[0].date,
                                            thesisPresentationId: thesisPresentationRes.data[0].id,
                                            thesisPresentationOptLock: thesisPresentationRes.data[0].optLock,
                                        };


                                        axios.get(`/students/thesis-presentation-mark/${thesisPresentationRes.data[0].id}/`)
                                            .then(thesisPresentationMarkRes => {
                                                if (thesisPresentationMarkRes.data.length > 0) {
                                                    studentLock = {
                                                        ...studentLock,
                                                        mark: thesisPresentationMarkRes.data[0].mark && thesisPresentationMarkRes.data[0].mark.id ? thesisPresentationMarkRes.data[0].mark.id : null,
                                                        thesisPresentationMarkId: thesisPresentationMarkRes.data[0].id,
                                                        thesisPresentationMarkOptLock: thesisPresentationMarkRes.data[0].optLock,
                                                    };

                                                    axios.get(`/students/thesis-presentation-professors/${thesisPresentationRes.data[0].id}/`)
                                                        .then(thesisPresentationProfessorsRes => {
                                                            if (thesisPresentationProfessorsRes.data.length > 0) {
                                                                studentLock = {
                                                                    ...studentLock,
                                                                    mentorId: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'mentor') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'mentor').id,
                                                                    mentor: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'mentor') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'mentor').employee.id,
                                                                    comentor: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'comentor') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'comentor').employee.id,
                                                                    comentorId: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'comentor') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'comentor').id,
                                                                    committeePresident: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'president') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'president').employee.id,
                                                                    committeePresidentId: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'president') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'president').id,
                                                                    committeeMember1: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'first_member') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'first_member').employee.id,
                                                                    committeeMember1Id: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'first_member') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'first_member').id,
                                                                    committeeMember2: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'second_member') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'second_member').employee.id,
                                                                    committeeMember2Id: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'second_member') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'second_member').id,
                                                                    reservedMember: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'reserve_member') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'reserve_member').employee.id,
                                                                    reservedMemberId: thesisPresentationProfessorsRes.data.find(el => el.role._key === 'reserve_member') && thesisPresentationProfessorsRes.data.find(el => el.role._key === 'reserve_member').id,
                                                                };

                                                                this.setState({
                                                                    studentLock,
                                                                    thesis: true,
                                                                    loader: false

                                                                });
                                                            } else {
                                                                this.setState({
                                                                    studentLock,
                                                                    thesis: true,
                                                                });
                                                                this.setState({ loader: false });
                                                            }
                                                        });
                                                } else {
                                                    this.setState({
                                                        studentLock,
                                                        thesis: true,
                                                    });
                                                    this.setState({ loader: false });
                                                }
                                            });
                                    } else {
                                        this.setState({
                                            studentLock,
                                            thesis: true,
                                        });
                                        this.setState({ loader: false });
                                    }
                                })
                                .catch(thesisPresentationErr => {
                                    this.setState({
                                        studentLock,
                                        thesis: true,
                                    });
                                });
                        } else {
                            this.setState({
                                studentLock,
                                loader: false
                            });
                        }
                    })
                    .catch(thesisErr => {
                        console.log(thesisErr);
                        this.setState({
                            studentLock,
                        });
                    });
            })
            .catch(err => {
                console.log(err);
            });
    }

    handleInputChange(e, { name, value }) {
        if (name === 'theme') {
            if (value !== '' || value !== '-') { this.setState({ disabled: false }); } else { this.setState({ disabled: true }); }
        }
        if (name === 'comentor' && !value) {
            this.setState(prevState => ({
                studentLock: {
                    ...prevState.studentLock,
                    committeeMember2: null,
                },
            }));
        }
        this.setState(prevState => ({
            studentLock: {
                ...prevState.studentLock,
                [name]: value,
            },
        }));
    }

    handleInputChange_(event) {
        const { target } = event;
        const { value } = target;
        const { name } = target;

        this.setState({
            [name]: value
        });
    }
    handleDateChange(e, isThesis, isThemeApprovalDecisionDate, isCommitteeAppointmentDecisionDate) {
        if (isThesis) {
            this.setState(prevState => ({
                studentLock: {
                    ...prevState.studentLock,
                    thesisDate: e,
                },
            }));
        } else if (isCommitteeAppointmentDecisionDate) {
            this.setState(prevState => ({
                studentLock: {
                    ...prevState.studentLock,
                    committeeAppointmentDecisionDate: e,
                },
            }));
        } else if (isThemeApprovalDecisionDate) {
            this.setState(prevState => ({
                studentLock: {
                    ...prevState.studentLock,
                    themeApprovalDecisionDate: e,
                },
            }));
        } else {
            this.setState(prevState => ({
                studentLock: {
                    ...prevState.studentLock,
                    date: e,
                },
            }));
        }
    }

    handleToggleThesis(isShown) {
        this.setState(prevState => ({
            thesis: isShown,
        }));
    }

    saveButtonValidation() {
        const {
            theme,
            // mark, diplomaNumber, thesisDate, date
        } = this.state.studentLock;

        if ((!(this.state.disableRight || this.state.disableInput) && !theme)
        // || (!(this.state.disableRight || this.state.disableInput) && !mark) || (!(this.state.disableRight || this.state.disableInput) && !thesisDate) || !diplomaNumber || !date
        ) {
            if (!(this.state.disableRight || this.state.disableInput) && !theme) { this.setState({ themeErr: true }); } else this.setState({ themeErr: false });
            // if (!(this.state.disableRight || this.state.disableInput) && !mark) { this.setState({ markErr: true }); } else this.setState({ markErr: false });
            // if (!diplomaNumber) { this.setState({ diplomaNumberErr: true }); } else this.setState({ diplomaNumberErr: false });
            // if (!thesisDate) { this.setState({ thesisDateErr: true }); } else this.setState({ thesisDateErr: false });
            // if (!date) { this.setState({ dateErr: true }); } else this.setState({ dateErr: false });
            toast('Niste unijeli sva obavezna polja!');
            return false;
        }

        this.setState({
            // diplomaNumberErr: false,
            thesisDateErr: false,
            // dateErr: false,
            // markErr: false
        });
        return true;
    }

    saveZR1Validation() {
        const {
            theme, themeEnglish, mentor
        } = this.state.studentLock;

        if ((!(this.state.disableRight || this.state.disableInput) && !theme) || (!(this.state.disableRight || this.state.disableInput) && !themeEnglish) || (!(this.state.disableRight || this.state.disableInput) && !mentor)) {
            if (!(this.state.disableRight || this.state.disableInput) && !theme) { this.setState({ themeErr: true }); } else this.setState({ themeErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !themeEnglish) { this.setState({ themeEnglishErr: true }); } else this.setState({ themeEnglishErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !mentor) { this.setState({ mentorErr: true }); } else this.setState({ mentorErr: false });

            toast('Niste unijeli sva obavezna polja!');
            return false;
        }

        this.setState({ themeEnglishErr: false, themeErr: false, mentorErr: false });
        return true;
    }

    saveZR2Validation() {
        const {
            theme, themeEnglish, mentor, committeePresident, committeeMember1
        } = this.state.studentLock;

        if ((!(this.state.disableRight || this.state.disableInput) && !theme) ||
            (!(this.state.disableRight || this.state.disableInput) && !themeEnglish) ||
            (!(this.state.disableRight || this.state.disableInput) && !mentor) ||
            (!(this.state.disableRight || this.state.disableInput) && !committeePresident) ||
            (!(this.state.disableRight || this.state.disableInput) && !committeeMember1)
        ) {
            if (!(this.state.disableRight || this.state.disableInput) && !theme) { this.setState({ themeErr: true }); } else this.setState({ themeErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !themeEnglish) { this.setState({ themeEnglishErr: true }); } else this.setState({ themeEnglishErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !mentor) { this.setState({ mentorErr: true }); } else this.setState({ mentorErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !committeePresident) { this.setState({ committeePresidentErr: true }); } else this.setState({ committeePresidentErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !committeeMember1) { this.setState({ committeeMember1Err: true }); } else this.setState({ committeeMember1Err: false });

            toast('Niste unijeli sva obavezna polja!');
            return false;
        }

        this.setState({
            themeEnglishErr: false, themeErr: false, mentorErr: false, committeePresidentErr: false, committeeMember1Err: false
        });
        return true;
    }

    saveZR3Validation() {
        const {
            theme, themeEnglish, themeApprovalDecisionNumber, themeApprovalDecisionDate
        } = this.state.studentLock;

        if ((!(this.state.disableRight || this.state.disableInput) && !theme) ||
            (!(this.state.disableRight || this.state.disableInput) && !themeEnglish) ||
            (!(this.state.disableRight || this.state.disableInput) && !themeApprovalDecisionNumber) ||
            (!(this.state.disableRight || this.state.disableInput) && !themeApprovalDecisionDate)
        ) {
            if (!(this.state.disableRight || this.state.disableInput) && !theme) { this.setState({ themeErr: true }); } else this.setState({ themeErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !themeEnglish) { this.setState({ themeEnglishErr: true }); } else this.setState({ themeEnglishErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !themeApprovalDecisionNumber) { this.setState({ themeApprovalDecisionNumberErr: true }); } else this.setState({ themeApprovalDecisionNumberErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !themeApprovalDecisionDate) { this.setState({ themeApprovalDecisionDateErr: true }); } else this.setState({ themeApprovalDecisionDateErr: false });

            toast('Niste unijeli sva obavezna polja!');
            return false;
        }

        this.setState({
            themeEnglishErr: false, themeErr: false, themeApprovalDecisionNumberErr: false, themeApprovalDecisionDateErr: false
        });
        return true;
    }

    saveZR4Validation() {
        this.saveZR1Validation();
    }

    saveZR5Validation() {
        const {
            theme, themeEnglish, mentor, committeePresident, committeeMember1, committeeAppointmentDecisionNumber, committeeAppointmentDecisionDate
        } = this.state.studentLock;

        if ((!(this.state.disableRight || this.state.disableInput) && !theme) ||
            (!(this.state.disableRight || this.state.disableInput) && !themeEnglish) ||
            (!(this.state.disableRight || this.state.disableInput) && !mentor) ||
            (!(this.state.disableRight || this.state.disableInput) && !committeePresident) ||
            (!(this.state.disableRight || this.state.disableInput) && !committeeAppointmentDecisionNumber) ||
            (!(this.state.disableRight || this.state.disableInput) && !committeeAppointmentDecisionDate) ||
            (!(this.state.disableRight || this.state.disableInput) && !committeeMember1)
        ) {
            if (!(this.state.disableRight || this.state.disableInput) && !theme) { this.setState({ themeErr: true }); } else this.setState({ themeErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !themeEnglish) { this.setState({ themeEnglishErr: true }); } else this.setState({ themeEnglishErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !mentor) { this.setState({ mentorErr: true }); } else this.setState({ mentorErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !committeePresident) { this.setState({ committeePresidentErr: true }); } else this.setState({ committeePresidentErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !committeeMember1) { this.setState({ committeeMember1Err: true }); } else this.setState({ committeeMember1Err: false });
            if (!(this.state.disableRight || this.state.disableInput) && !committeeAppointmentDecisionNumber) { this.setState({ committeeAppointmentDecisionNumberErr: true }); } else this.setState({ committeeAppointmentDecisionNumberErr: false });
            if (!(this.state.disableRight || this.state.disableInput) && !committeeAppointmentDecisionDate) { this.setState({ committeeAppointmentDecisionDateErr: true }); } else this.setState({ committeeAppointmentDecisionDateErr: false });

            toast('Niste unijeli sva obavezna polja!');
            return false;
        }

        this.setState({
            themeEnglishErr: false, themeErr: false, mentorErr: false, committeePresidentErr: false, committeeMember1Err: false, committeeAppointmentDecisionNumberErr: false, committeeAppointmentDecisionDateErr: false
        });
        return true;
    }

    sendStudentLock(studentLock, hasThesis, isLocked) {
        // const { theme, mark, diplomaNumber } = this.state.studentLock;
        //
        // if ((!(this.state.disableRight || this.state.disableInput) && !mark) || !diplomaNumber || (!(this.state.disableRight || this.state.disableInput) && !theme)) {
        //     if (!(this.state.disableRight || this.state.disableInput) && !theme) { this.setState({ themeErr: true }); } else this.setState({ themeErr: false });
        //     if (!(this.state.disableRight || this.state.disableInput) && !mark) { this.setState({ markErr: true }); } else this.setState({ markErr: false });
        //     if (!diplomaNumber) { this.setState({ diplomaNumberErr: true }); } else this.setState({ diplomaNumberErr: false });
        //     toast('Niste unijeli sva obavezna polja!');
        //     return;
        // }
        //
        // this.setState({ diplomaNumberErr: false, themeErr: false, markErr: false });
        const {
            studentStudyProgramId,
        } = this.props;
        let studentLockRequest;
        let language = { twoLetterCode: 'en' };
        let translations = [{ additionalActivities: this.state.studentLock.additionalActivities, language }];

        let studentStudyProgram = {
            translations,
            id: studentStudyProgramId,
            optLock: studentLock.optLock,
            diplomaNumber: studentLock.diplomaNumber,
            locked: isLocked ? 1 : 0,
            additionalActivities: studentLock.comment,
            graduationDate: studentLock.date,
        };

        if (hasThesis) {
            let language = { twoLetterCode: 'en' };
            let translations = [{ theme: this.state.studentLock.themeEnglish, language }];
            studentLockRequest = {
                studentStudyProgram,
                thesis: {
                    translations: this.state.studentLock.themeEnglish !== null ? translations : null,
                    theme: studentLock.theme,
                    comment: studentLock.thesisComment,
                    id: studentLock.thesisId,
                    optLock: studentLock.thesisOptLock,
                    themeApprovalDecisionNumber: studentLock.themeApprovalDecisionNumber,
                    themeApprovalDecisionDate: studentLock.themeApprovalDecisionDate,
                    committeeAppointmentDecisionNumber: studentLock.committeeAppointmentDecisionNumber,
                    committeeAppointmentDecisionDate: studentLock.committeeAppointmentDecisionDate
                },
                thesisPresentation: {
                    date: studentLock.thesisDate,
                    id: studentLock.thesisPresentationId,
                    optLock: studentLock.thesisPresentationOptLock,
                },
                thesisPresentationMark: {
                    mark: studentLock.mark ? { id: studentLock.mark } : null,
                    id: studentLock.thesisPresentationMarkId,
                    optLock: studentLock.thesisPresentationMarkOptLock,
                },
                thesisPresentationProfessors: [
                    {
                        id: studentLock.mentorId ? studentLock.mentorId : null,
                        employee: studentLock.mentor ? { id: studentLock.mentor } : null,
                        role: this.state.committeeRoles.find(el => el._key === 'mentor')
                    },
                    {
                        id: studentLock.committeePresidentId ? studentLock.committeePresidentId : null,
                        employee: studentLock.committeePresident ? { id: studentLock.committeePresident } : null,
                        role: this.state.committeeRoles.find(el => el._key === 'president')
                    },
                    {
                        id: studentLock.committeeMember1Id ? studentLock.committeeMember1Id : null,
                        employee: studentLock.committeeMember1 ? { id: studentLock.committeeMember1 } : null,
                        role: this.state.committeeRoles.find(el => el._key === 'first_member')
                    },
                    {
                        id: studentLock.reservedMemberId ? studentLock.reservedMemberId : null,
                        employee: studentLock.reservedMember ? { id: studentLock.reservedMember } : null,
                        role: this.state.committeeRoles.find(el => el._key === 'reserve_member')
                    }
                ]

            };

            if (studentLock.comentor) {
                studentLockRequest = {
                    ...studentLockRequest,
                    thesisPresentationProfessors: [
                        ...studentLockRequest.thesisPresentationProfessors,
                        {
                            id: studentLock.comentorId ? studentLock.comentorId : null,
                            employee: studentLock.comentor ? { id: studentLock.comentor } : null,
                            role: this.state.committeeRoles.find(el => el._key === 'comentor')
                        },
                        {
                            id: studentLock.committeeMember2Id ? studentLock.committeeMember2Id : null,
                            employee: studentLock.committeeMember2 ? { id: studentLock.committeeMember2 } : null,
                            role: this.state.committeeRoles.find(el => el._key === 'second_member')
                        }
                    ]
                };
            }
        } else {
            studentLockRequest = {
                studentStudyProgram,
            };
        }

        if (studentStudyProgramId === null) {
            return;
        }

        let markObj = {
            markId: studentLock.mark,
            studentStudyProgramId: this.props.studentStudyProgramId,
            date: studentLock.thesisDate
        };

        axios.post('/students/graduation-data/', { ...studentLockRequest })
            .then(res => {
                // eslint-disable-next-line no-unused-expressions
                this.props.updateStudentStatuses();
                this.props.toggleGraduationVisibility();
                if (studentLock.mark) {
                    axios.post('/students/graduation-mark/', { ...markObj })
                        .then(re => {
                            toast('Podaci o završetku ciklusa studija su uspješno sačuvani.');
                            this.checkNotPassedCourses(this.props.studentStudyProgramId);
                            this.fetchData(this.props.studentStudyProgramId);
                        })
                        .catch((err) => {
                            console.log('moj err: ', err.message);
                            if (err.message === 'Network Error') {
                                this.checkNotPassedCourses(this.props.studentStudyProgramId);
                                this.fetchData(this.props.studentStudyProgramId);
                                toast('Podaci o završetku ciklusa studija su uspješno sačuvani.');
                            } else {
                                toast.error('Došlo je do greške prilikom dodavanja ocjene na završnom radu.');
                            }
                        });
                } else {
                    toast('Podaci o završetku ciklusa studija su uspješno sačuvani.');
                    this.checkNotPassedCourses();
                    this.fetchData(this.props.studentStudyProgramId);
                }
            })
            .catch(err => {
                if (err.message === 'Network Error') {
                    this.checkNotPassedCourses(this.props.studentStudyProgramId);
                    this.fetchData(this.props.studentStudyProgramId);
                    toast('Podaci o završetku ciklusa studija su uspješno sačuvani.');
                } else {
                    toast.error('Došlo je do greške prilikom dodavanja ocjene na završnom radu.');
                }
            });

        if (this.state.sendPfInfo) {
            this.sendAdditionalInfoForPf();
        }
    }
    checkFinalData() {
        const {
            studentStudyProgramId,
        } = this.props;
        axios.get(`course/implementations/final/${studentStudyProgramId}/`).then((res) => {
            if (res.data.length === 0) {
                // nije upisan
                this.setState({ notEnrolled: true, loader: false });
                // this.fetchLookups();
            } else {
                // upisan na zavrsni
                this.setState({ notEnrolled: false });
                this.fetchLookups();
            }
        }).catch((err) => {
            console.log('Failed to check final data!');
            toast('Došlo je do greške! Provjera da li je student upisan na završni rad nije uspjela.');
        });
    }

    checkFinalCourseOnSp() {
        const {
            studentStudyProgramId,
            studyProgramId
        } = this.props;
        axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support')
            ? `study-programs/final-course-existence-check/${studyProgramId}/${localStorage.getItem('orgUnit')}`
            : `study-programs/final-course-existence-check/${studyProgramId}/`)
            .then((res) => {
                if (res.data) {
                // postoji zavrsni, provjeriti da li je upisan student
                    this.setState({ hasFinal: true });
                    this.checkFinalData();
                } else {
                    this.setState({ disableRight: true, hasFinal: false });
                    this.fetchLookups();
                }
            }).catch((err) => {
                console.log('Failed to check final course on sp!');
                toast('Došlo je do greške! Provjera da li sp ima završni rad nije uspjela.');
            });
    }

    render() {
        const {
            diplomaNumber,
            comment,
            additionalActivities,
            date,
            theme,
            themeEnglish,
            thesisDate,
            mark,
            thesisComment,
            themeApprovalDecisionDate,
            themeApprovalDecisionNumber,
            committeeAppointmentDecisionDate,
            committeeAppointmentDecisionNumber,
            mentor,
            comentor,
            committeePresident,
            committeeMember1,
            committeeMember2,
            reservedMember
        } = this.state.studentLock;
        const { notPassedCourses } = this.state;
        return (
            <div>

                {notPassedCourses && <Message
                    warning
                > <Icon name="warning sign" color="brown" /><b>Student ima nepoloženih predmeta.</b></Message>}

                {
                    this.state.loader ?
                        <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>

                        : <Fragment>
                            {this.state.hasFinal && <Fragment>
                                {/* <br /> */}
                                <Divider horizontal>
                                    <Header as="h4">Podaci o završnom radu <br />

                                        {
                                            this.state.hasFinal ?
                                                (!this.state.loader && this.state.notEnrolled) ?
                                                    <span style={{
                                                        fontSize: '13px',
                                                        fontWeight: 'normal',
                                                        color: 'red'
                                                    }}
                                                    ><i>Student nije upisan na diplomski (završni) rad!</i></span>
                                                    :
                                                    <span style={{
                                                        fontSize: '13px',
                                                        fontWeight: 'normal'
                                                    }}
                                                    ><i>Podaci o diplomskom (završnom) radu.</i></span>
                                                :
                                                <span style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'normal'
                                                }}
                                                    ><i>Studijski program nema diplomski (završni) rad.</i></span>
                                        }
                                    </Header>

                                </Divider>

                                <Segment clearing secondary>
                                    <Grid columns={2}>
                                        <Grid.Column>
                                            <Form>

                                                <Form.Field
                                                    readOnly={this.props.limitation}
                                                    // required={!(this.state.disableRight || this.state.notEnrolled)}
                                                    error={this.state.themeErr}

                                                    label="Tema"
                                                    control={TextArea}
                                                    disabled={this.state.disableRight || this.state.notEnrolled}
                                                    name="theme"
                                                    rows={2}
                                                    value={theme}
                                                    onChange={this.handleInputChange}
                                                    placeholder="Unesite temu"
                                                />

                                                <Form.Group widths="equal">
                                                    <Form.Field
                                                        readOnly={this.props.limitation}
                                                        label="Broj odluke imenovanja komisije"
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        control={Input}
                                                        name="committeeAppointmentDecisionNumber"
                                                        value={committeeAppointmentDecisionNumber}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Unesite broj odluke"
                                                        error={this.state.committeeAppointmentDecisionNumberErr}

                                                    />
                                                    <Form.Field
                                                        readOnly={this.props.limitation}
                                                        control={DateTimePicker}
                                                        label="Datum imenovanja komisije"
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        onChange={(e) => this.handleDateChange(e, false, false, true)}
                                                        value={committeeAppointmentDecisionDate ? new Date(committeeAppointmentDecisionDate) : null}
                                                        style={{ borderWidth: '0px' }}
                                                        error={this.state.committeeAppointmentDecisionDateErr}
                                                    />

                                                </Form.Group>
                                                <Form.Group widths="equal">

                                                    {this.props.limitation ? (
                                                        <Form.Field
                                                            readOnly={this.props.limitation}
                                                            label="Mentor"
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            control={Input}
                                                            value={this.state.employees.find(e => e.value === mentor) ? this.state.employees.find(e => e.value === mentor).text : ''}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Mentor"

                                                        />

                                                    ) : (
                                                        <Form.Dropdown
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            label="Mentor"
                                                            placeholder="Odaberite mentora"
                                                            value={mentor}
                                                            onChange={this.handleInputChange}
                                                            name="mentor"
                                                            options={this.state.employees}
                                                            search
                                                            fluid
                                                            selection
                                                            clearable
                                                            error={this.state.mentorErr}
                                                        />
                                                    )}
                                                    {this.props.limitation ? (
                                                        <Form.Field
                                                            readOnly={this.props.limitation}
                                                            label="Komentor"
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            control={Input}
                                                            value={this.state.employees.find(e => e.value === comentor) ? this.state.employees.find(e => e.value === comentor).text : ''}
                                                            placeholder="Komentor"

                                                        />

                                                    ) : (<Form.Dropdown
                                                        readOnly={this.props.limitation}
                                                        label="Komentor"
                                                        placeholder="Odaberite komentora"
                                                        value={comentor}
                                                        onChange={this.handleInputChange}
                                                        name="comentor"
                                                        options={this.state.employees}
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        search
                                                        fluid
                                                        selection
                                                        clearable
                                                    />)}
                                                </Form.Group>
                                                <Form.Group widths="equal">

                                                    {this.props.limitation ? (
                                                        <Form.Field
                                                            readOnly={this.props.limitation}
                                                            label="Predsjednik komisije"
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            control={Input}
                                                            value={this.state.employees.find(e => e.value === committeePresident) ? this.state.employees.find(e => e.value === committeePresident).text : ''}
                                                            placeholder="Predsjednik komisije"

                                                        />

                                                    ) : (<Form.Dropdown
                                                        readOnly={this.props.limitation}
                                                        label="Predsjednik komisije"
                                                        placeholder="Odaberite predsjednika"
                                                        value={committeePresident}
                                                        onChange={this.handleInputChange}
                                                        name="committeePresident"
                                                        options={this.state.employees}
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        search
                                                        fluid
                                                        selection
                                                        clearable
                                                        error={this.state.committeePresidentErr}
                                                    />)}
                                                    {this.props.limitation ? (
                                                        <Form.Field
                                                            readOnly={this.props.limitation}
                                                            label="Drugi član komisije"
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            control={Input}
                                                            value={this.state.employees.find(e => e.value === committeeMember2) ? this.state.employees.find(e => e.value === committeeMember2).text : ''}
                                                            placeholder="Drugi član komisije"

                                                        />

                                                    ) : (<Form.Dropdown
                                                        readOnly={this.props.limitation}
                                                        label="Drugi član komisije"
                                                        placeholder="Odaberite člana"
                                                        value={committeeMember2}
                                                        onChange={this.handleInputChange}
                                                        name="committeeMember2"
                                                        options={this.state.employees}
                                                        disabled={this.state.disableRight || this.state.notEnrolled || !comentor}
                                                        search
                                                        fluid
                                                        selection
                                                        clearable
                                                    />)}
                                                </Form.Group>
                                                <Form.Group widths="equal">
                                                    {this.props.limitation ? (
                                                        <Form.Field
                                                            readOnly={this.props.limitation}
                                                            label="Član komisije"
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            control={Input}
                                                            value={this.state.employees.find(e => e.value === committeeMember1) ? this.state.employees.find(e => e.value === committeeMember1).text : ''}
                                                            placeholder="Član komisije"

                                                        />

                                                    ) : (<Form.Dropdown
                                                        readOnly={this.props.limitation}
                                                        label="Član komisije"
                                                        placeholder="Odaberite člana"
                                                        value={committeeMember1}
                                                        onChange={this.handleInputChange}
                                                        name="committeeMember1"
                                                        options={this.state.employees}
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        search
                                                        fluid
                                                        selection
                                                        clearable
                                                        error={this.state.committeeMember1Err}
                                                    />)}

                                                    {this.props.limitation ? (
                                                        <Form.Field
                                                            readOnly={this.props.limitation}
                                                            label="Rezervni član komisije"
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            control={Input}
                                                            value={this.state.employees.find(e => e.value === reservedMember) ? this.state.employees.find(e => e.value === reservedMember).text : ''}
                                                            placeholder="Rezervni član komisije"

                                                        />

                                                    ) : (<Form.Dropdown
                                                        readOnly={this.props.limitation}
                                                        label="Rezervni član komisije"
                                                        placeholder="Odaberite rezervnog člana"
                                                        value={reservedMember}
                                                        onChange={this.handleInputChange}
                                                        name="reservedMember"
                                                        options={this.state.employees}
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        search
                                                        fluid
                                                        selection
                                                        clearable
                                                    />)}

                                                </Form.Group>

                                            </Form>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Form>

                                                <Form.Field
                                                    readOnly={this.props.limitation}
                                                    label="Tema na engleskom jeziku"
                                                    control={TextArea}
                                                    disabled={this.state.disableRight || this.state.notEnrolled}
                                                    name="themeEnglish"
                                                    rows={2}
                                                    value={themeEnglish}
                                                    onChange={this.handleInputChange}
                                                    placeholder="Unesite temu na engleskom jeziku"
                                                    error={this.state.themeEnglishErr}
                                                />
                                                <Form.Group widths="equal">
                                                    <Form.Field
                                                        readOnly={this.props.limitation}
                                                        label="Broj odluke odobrenja teme"
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        control={Input}
                                                        name="themeApprovalDecisionNumber"
                                                        value={themeApprovalDecisionNumber}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Unesite broj diplome"
                                                        error={this.state.themeApprovalDecisionNumberErr}

                                                    />
                                                    <Form.Field
                                                        readOnly={this.props.limitation}
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        control={DateTimePicker}
                                                        label="Datum odluke odobrenja teme"
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        onChange={(e) => this.handleDateChange(e, false, true, false)}
                                                        value={themeApprovalDecisionDate ? new Date(themeApprovalDecisionDate) : null}
                                                        style={{ borderWidth: '0px' }}
                                                        error={this.state.themeApprovalDecisionDateErr}
                                                    />
                                                </Form.Group>
                                                <Form.Group widths="equal">
                                                    <Form.Field
                                                        readOnly={this.props.limitation}
                                                        disabled={this.state.disableRight || this.state.notEnrolled}
                                                        control={DateTimePicker}
                                                        label="Datum odbrane"
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        onChange={(e) => this.handleDateChange(e, true, false, false)}
                                                        value={thesisDate ? new Date(thesisDate) : null}
                                                        style={{ borderWidth: '0px' }}
                                                        error={this.state.thesisDateErr}
                                                    />
                                                    {this.props.limitation ?
                                                        <Form.Field
                                                            readOnly
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            label="Ocjena"
                                                            control={Input}
                                                            name="mark"
                                                            value={mark ? this.state.marks.find(el => el.id === mark).name : null}
                                                        />
                                                        : <Form.Dropdown
                                                            label="Ocjena"
                                                            placeholder="Odaberite ocjenu"
                                                            value={mark}
                                                            onChange={this.handleInputChange}
                                                            name="mark"
                                                            options={this.state.marks}
                                                            disabled={this.state.disableRight || this.state.notEnrolled}
                                                            search
                                                            fluid
                                                            selection
                                                            error={this.state.markErr}
                                                        />}
                                                </Form.Group>

                                                <Form.Field

                                                    readOnly={this.props.limitation}
                                                    label="Dodatne informacije"
                                                    control={TextArea}
                                                    rows={5}
                                                    name="thesisComment"
                                                    disabled={this.state.disableRight || this.state.notEnrolled}
                                                    value={thesisComment}
                                                    onChange={this.handleInputChange}
                                                    placeholder="Unesite dodatne informacije"
                                                />


                                            </Form>
                                        </Grid.Column>
                                    </Grid>

                                </Segment>
                                {/* <br /> */}
                                {/* <Grid columns={6} stackable> */}
                                {/*     <Grid.Column> */}
                                {/*         <Button */}
                                {/*             fluid */}
                                {/*             basic */}
                                {/*             primary */}
                                {/*             onClick={ */}
                                {/*                 () => { */}
                                {/*                     if (this.saveZR1Validation()) { */}
                                {/*                         this.sendStudentLock(this.state.studentLock, !this.state.disabled, false); */}
                                {/*                     } */}
                                {/*                 } */}
                                {/*             } */}
                                {/*         >ZR1</Button> */}
                                {/*     </Grid.Column> */}
                                {/*     <Grid.Column> */}
                                {/*         <Button */}
                                {/*             fluid */}
                                {/*             basic */}
                                {/*             primary */}
                                {/*             onClick={ */}
                                {/*                 () => { */}
                                {/*                     if (this.saveZR2Validation()) { */}
                                {/*                         this.sendStudentLock(this.state.studentLock, !this.state.disabled, false); */}
                                {/*                     } */}
                                {/*                 } */}
                                {/*             } */}
                                {/*         >ZR2</Button> */}
                                {/*     </Grid.Column> */}
                                {/*     <Grid.Column> */}
                                {/*         <Button */}
                                {/*             fluid */}
                                {/*             basic */}
                                {/*             primary */}
                                {/*             onClick={ */}
                                {/*                 () => { */}
                                {/*                     if (this.saveZR3Validation()) { */}
                                {/*                         this.sendStudentLock(this.state.studentLock, !this.state.disabled, false); */}
                                {/*                     } */}
                                {/*                 } */}
                                {/*             } */}
                                {/*         >ZR3</Button> */}
                                {/*     </Grid.Column> */}
                                {/*     <Grid.Column> */}
                                {/*         <Button */}
                                {/*             fluid */}
                                {/*             basic */}
                                {/*             primary */}
                                {/*             onClick={ */}
                                {/*                 () => { */}
                                {/*                     if (this.saveZR4Validation()) { */}
                                {/*                         this.sendStudentLock(this.state.studentLock, !this.state.disabled, false); */}
                                {/*                     } */}
                                {/*                 } */}
                                {/*             } */}
                                {/*         >ZR4</Button> */}
                                {/*     </Grid.Column> */}
                                {/*     <Grid.Column> */}
                                {/*         <Button */}
                                {/*             fluid */}
                                {/*             basic */}
                                {/*             primary */}
                                {/*             onClick={ */}
                                {/*                 () => { */}
                                {/*                     if (this.saveZR5Validation()) { */}
                                {/*                         this.sendStudentLock(this.state.studentLock, !this.state.disabled, false); */}
                                {/*                     } */}
                                {/*                 } */}
                                {/*             } */}
                                {/*         >ZR5</Button> */}
                                {/*     </Grid.Column> */}
                                {/*     <Grid.Column> */}
                                {/*         <Button */}
                                {/*             fluid */}
                                {/*             basic */}
                                {/*             primary */}
                                {/*             disabled */}
                                {/*             onClick={ */}
                                {/*                 () => { */}
                                {/*                     if (this.saveZR1Validation()) { */}
                                {/*                         this.sendStudentLock(this.state.studentLock, !this.state.disabled, false); */}
                                {/*                     } */}
                                {/*                 } */}
                                {/*             } */}
                                {/*         >ZR6</Button> */}
                                {/*     </Grid.Column> */}
                                {/* </Grid> */}

                                {/* <br /> */}
                            </Fragment>}
                            <Divider horizontal>
                                <Header as="h4">Podaci o diplomiranju<br />
                                    <span style={{ fontSize: '13px', fontWeight: 'normal' }}><i>Ovi podaci se prikazuju na dodatku diplomi.</i></span>
                                </Header>
                            </Divider>
                            <Segment clearing secondary>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field
                                            readOnly={this.props.limitation}

                                            label="Broj izdate diplome"
                                            disabled={this.state.notEnrolled}
                                            control={Input}
                                            name="diplomaNumber"
                                            value={diplomaNumber}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite broj diplome"
                                            error={this.state.diplomaNumberErr}

                                        />
                                        <Form.Field
                                            readOnly={this.props.limitation}
                                            control={DateTimePicker}
                                            label="Datum diplomiranja"
                                            format="D. M. YYYY."
                                            time={false}
                                            disabled={this.state.notEnrolled}
                                            onChange={(e) => this.handleDateChange(e, false, false, false)}
                                            value={date ? new Date(date) : null}
                                            style={{ borderWidth: '0px' }}
                                            error={this.state.dateErr}
                                        />
                                    </Form.Group>
                                    <Form.Group widths="equal">
                                        <Form.Field
                                            readOnly={this.props.limitation}
                                            label="Dodatne informacije"
                                            control={TextArea}
                                            name="comment"
                                            rows={5}
                                            value={comment}
                                            defaultValue={comment}
                                            disabled={this.state.notEnrolled}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite dodatne informacije"
                                        />
                                        <Form.Field
                                            readOnly={this.props.limitation}
                                            label="Dodatne informacije na engleskom jeziku"
                                            control={TextArea}
                                            name="additionalActivities"
                                            rows={5}
                                            value={additionalActivities}
                                            defaultValue={additionalActivities}
                                            disabled={this.state.notEnrolled}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite dodatne informacije na engleskom jeziku"
                                        />
                                    </Form.Group>

                                </Form>
                            </Segment>

                        </Fragment>
                }


                <Divider />
                {(this.props.locked && (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator')) ?
                    this.state.confirmationUnlock ?
                        <div style={{ float: 'left' }}>
                            <h4>Jeste li sigurni?</h4>
                            <Button.Group >
                                <Button
                                    basic="true"
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.unlock();
                                        }
                                    }
                                > DA</Button>
                                <Button
                                    basic="true"
                                    color="red"
                                    onClick={() => { this.setState({ confirmationUnlock: false }); }}
                                >  NE

                                </Button>
                            </Button.Group></div> :
                        <Button
                            floated="left"
                            icon
                            labelPosition="left"
                            color="teal"
                            onClick={
                                () => {
                                    this.setState({ confirmationUnlock: true });
                                }
                            }
                        ><Icon className="lock open" />Otključaj studenta</Button> : null}
                {(!this.props.limitation && !this.state.hideButtons) && <div clearing>
                    <Button
                        disabled={this.state.notEnrolled || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                        floated="right"
                        color="blue"
                        onClick={
                            () => {
                                if (this.saveButtonValidation()) {
                                    this.sendStudentLock(this.state.studentLock, !this.state.disabled, false);
                                }
                            }
                        }
                    >Sačuvaj podatke</Button>
                    {this.state.confirmation ?
                        <div style={{ float: 'left' }}>
                            <h4>Jeste li sigurni?</h4>
                            <Button.Group >
                                <Button
                                    basic="true"
                                    color="blue"
                                    onClick={this.lock}
                                > DA</Button>
                                <Button
                                    basic="true"
                                    color="red"
                                    onClick={() => { this.setState({ confirmation: false }); }}
                                >  NE

                                </Button>
                            </Button.Group></div>
                        : this.state.hideButtons ? null :
                        <Button
                                disabled={!this.props.graduationDate || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                floated="left"
                                icon
                                labelPosition="left"
                                color="red"
                                onClick={
                                    () => {
                                        this.setState({ confirmation: true });
                                    }
                                }
                            ><Icon className="lock" />Zaključaj studenta</Button>
                    }
                    <br /><br /></div>}
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

StudentLockForm.defaultProps = {
    sendStudentLock: (studentLock) => {
        axios.post('/students/lock/', { ...studentLock })
            .then(toast('Student je uspješno zaključan.'))
            .catch((err) => {
                if (err.message === 'Network Error') {
                    toast('Student je uspješno zaključan.');
                } else {
                    toast('Došlo je do greške! Student nije zaključan.');
                }
            });
    },
    studentStudyProgramId: null,
};

StudentLockForm.propTypes = {
    sendStudentLock: PropTypes.func,
    studentStudyProgramId: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentLockForm.js